var map = {
	"./campfire.mp3": 3870,
	"./forest.mp3": 3871,
	"./ocean.mp3": 3872,
	"./river.mp3": 3873,
	"./savanna.mp3": 3874,
	"./storm.mp3": 3875
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 684;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background .\.mp3*
// module id = 684
// module chunks = 0